<section>
    <div class="bg-white p-6">
        <h1 class="typography-title-m m-0">
            {{'create-claim.classification.claim_classification' | translate}}
        </h1>
        <div class="divider mt-3 mb-6"></div>

<!--        Info card-->
        <div class="bg-info-background p-2 mb-6 flex gap-2">
            <img class="w-[24px] h-[24px]" src="assets/icons/info.svg" alt="info">
            <div class="flex flex-col gap-1">
                <p class="m-0 typography-body-m-medium">
                    {{'create-claim.classification.we_updated_the_classification' | translate}}
                </p>
                <p class="m-0 typography-body-m-regular">
                    {{'create-claim.classification.we_updated_the_classification_description' | translate}}
                </p>
            </div>
        </div>

        <div>
<!--            Select options-->
            <div class="mb-6 grid grid-cols-1 gap-3 md:gap-6 md:grid-cols-[repeat(2,1fr)] lg:grid-cols-[repeat(8,1fr)]">
                <div class="col-span-1 lg:col-span-3">
                    <label class="typography-body-m-medium">
                        {{'create-claim.classification.indicate_product_type' | translate}}:
                    </label>
                    <div class="mt-2">
                        <app-select
                            [searchable]="false"
                            [options]="productTypeOptions"
                            [selectedValue]="productType"
                            [isClearable]="false"
                            [placeholder]="'select' | translate"
                            (selectedValueChanged)="onProductTypeSelected($event)"
                        ></app-select>
                    </div>
                </div>
                <div class="col-span-1 lg:col-span-3">
                    <label class="typography-body-m-medium">
                        {{'create-claim.classification.indicate_incident_place' | translate}}:
                    </label>
                    <div class="mt-2">
                        <app-select
                            [searchable]="false"
                            [options]="claimPlaceOptions"
                            [selectedValue]="claimPlace"
                            [isClearable]="false"
                            [placeholder]="'select' | translate"
                            [disabled]="isClaimTypeDisabled"
                            (selectedValueChanged)="onClaimPlaceSelected($event)"
                        ></app-select>
                    </div>
                </div>
            </div>

<!--            Claim type-->
            <div class="flex flex-col gap-4" [ngClass]="{ 'invisible': !shouldShowClaimType() }">
                <p class="m-0 typography-body-m-medium">
                    {{'create-claim.classification.indicate_claim_type' | translate}}:
                </p>
                <ng-container *ngFor="let claimType of claimTypeOptions">
                    <div
                        *ngIf="(claimType.value !== 'broken' || (claimPlace && claimPlace.value === 'in_shop')) && (claimType.value !== 'installation' || (claimPlace && claimPlace.value !== 'in_shop'))"
                        class="flex gap-2 cursor-pointer items-center"
                        (click)="onClaimTypeSelected(claimType, true)"
                    >
                        <app-radio [checked]="claimType.selected" />
                        <div>
                            <span class="typography-body-m-medium">{{claimType.title + (claimType.description ? ': ' : '')}}</span>
                            <span *ngIf="claimType.description" class="typography-body-m-light">{{claimType.description}}</span>
                        </div>
                    </div>
                </ng-container>
            </div>

            <ng-container *ngIf="claimPlace && claimPlace.value === 'installation'">

                <div class="flex flex-col gap-4 mt-6">
                    <p class="m-0 typography-body-m-medium">
                        {{'create-claim.classification.indicate_the_affected_customer' | translate}}*:
                    </p>

                    <div
                        class="flex gap-2 cursor-pointer items-center"
                        (click)="onMyOwnCustomerSelected()"
                    >
                        <app-radio [checked]="isMyOwnCustomer" />
                        <div>
                            <span class="typography-body-m-medium">{{'create-claim.classification.customer_of_my_company' | translate}}</span>
                            <span class="typography-body-m-light">:&nbsp;{{'create-claim.classification.customer_of_my_company_description' | translate}}</span>
                        </div>
                    </div>
                    <div
                        class="flex gap-2 cursor-pointer items-center"
                        (click)="onPartnerStoreCustomerSelected()"
                    >
                        <app-radio [checked]="isPartnerStoreCustomer" />
                        <div>
                            <span class="typography-body-m-medium">{{'create-claim.classification.customer_of_partner_store' | translate}}</span>
                            <span class="typography-body-m-light">:&nbsp;{{'create-claim.classification.customer_of_partner_store_description' | translate}}</span>
                        </div>
                    </div>
                    <div *ngIf="isPartnerStoreCustomer" class="px-8 grid grid-cols-1 md:grid-cols-[repeat(2,1fr)] lg:grid-cols-[repeat(3,1fr)]">
                        <div class="col-span-1">
                            <app-select
                                [customBoxHeight]="'120px'"
                                [options]="partnerStores"
                                [selectedValue]="selectedPartnerStore"
                                [searchable]="false"
                                [isClearable]="false"
                                [placeholder]="'select' | translate"
                                (selectedValueChanged)="onPartnerStoreSelected($event)"
                            ></app-select>
                        </div>
                    </div>
                </div>

            </ng-container>
        </div>
    </div>
</section>
